// extracted by mini-css-extract-plugin
module.exports = {"description":"VerificationStepContent_description__3pHq_","content-wrapper":"VerificationStepContent_content-wrapper__2npgZ","content":"VerificationStepContent_content__3L459"};